import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { GeneralError, v5Theme as theme } from '@zaplify/ui';
import { useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux-latest';
import { BrowserRouter as Router } from 'react-router-dom';
import { WebSocketProvider } from './providers/websocket-provider';
import { configureStore } from './redux/store';
import { Routes } from './routes/routes';
import SocketClient from './services/utils/sockets/socketClient';
import { useAtomsDevtools } from 'jotai-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const AtomsDevtools = ({ children }) => {
    useAtomsDevtools('Zaplify Jotai Devtools');
    return children;
};

const queryClient = new QueryClient();

const App = ({ instance }) => {
    const store = useRef(
        configureStore({
            socketClient: new SocketClient(),
            msal: instance,
        })
    );

    // const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const handleRedirect = () => {
        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'create',
            })
            .catch((error) => console.log(error));
    };

    return (
        <Router>
            <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => {
                    console.error('ReactRenderingError:', error);
                    return <GeneralError error={error} resetErrorBoundary={resetErrorBoundary} />;
                }}
                onReset={(details) => {
                    console.error(details);
                    window.location.reload();
                }}
            >
                <Provider store={store.current}>
                    <QueryClientProvider client={queryClient}>
                        {/* <div className="App">
                                                    <AuthenticatedTemplate>
                                                        {activeAccount ? (
                                                            <Container>
                                                                <IdTokenData idTokenClaims={activeAccount.idTokenClaims} />
                                                            </Container>
                                                        ) : null}
                                                    </AuthenticatedTemplate>
                                                    <UnauthenticatedTemplate>
                                                        <Button className="signInButton" onClick={handleRedirect}>
                                                            Sign up
                                                        </Button>
                                                    </UnauthenticatedTemplate>
                                                </div> */}
                        <MsalProvider instance={instance}>
                            <WebSocketProvider>
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={theme}>
                                        <AtomsDevtools>
                                            <Routes />
                                        </AtomsDevtools>
                                    </ThemeProvider>
                                </StyledEngineProvider>
                            </WebSocketProvider>
                        </MsalProvider>
                    </QueryClientProvider>
                </Provider>
            </ErrorBoundary>
        </Router>
    );
};

export default App;
